module.exports = __webpack_public_path__ + "media/images/icons/pix-logo-blue-c473553ee1715c182acccb76530cd685.svg";